module.exports = __webpack_public_path__ + "static/media/visualizacion-logo-caracol-tv-1979-1981@3x.d7eff467.png";